import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export class Video {
  public embedUrl: SafeResourceUrl;
  constructor(public id: string,
              public title: string,
              public description: string,
              public thumbnailUrl: string,
              private sanitizer: DomSanitizer) {
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.youtube.com/embed/' + this.id + '?autoplay=0&showinfo=0&enablejsapi=1&origin=https://fairylullaby.com&color=white');
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/video.ts